import { createContext, useContext } from 'react'

export const UserContext = createContext(undefined)

export const useUserContext = () => {
  const user = useContext(UserContext)
  return user
}
